/* eslint-disable */
import React, { useCallback } from 'react';
import { useIntl } from '@lumahealthhq/ui-components';
import { Button, IconRefresh } from '@lumahealthhq/ui-core';
import { useLogger } from '@lumahealthhq/ui-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function useFallbackRender(module) {
  var logger = useLogger();
  var intl = useIntl();
  var fallbackRender = useCallback(function (_ref) {
    var error = _ref.error;
    logger.error(module, error);
    return /*#__PURE__*/_jsxs(Button, {
      variant: "primary",
      sx: {
        height: '40px'
      },
      onClick: function onClick() {
        return window.location.reload();
      },
      children: [/*#__PURE__*/_jsx(IconRefresh, {
        fontSize: "small",
        sx: {
          mr: 1
        }
      }), intl.formatMessage({
        id: "jsy7pk",
        defaultMessage: [{
          "type": 0,
          "value": "Try Again"
        }]
      })]
    });
  }, [module]);
  return fallbackRender;
}